export enum BatchStatisticsLevel {
  RXP_APPROVED = 'TotalApprovedInReviewByHost',
  RXP_APPROVED_MFG_REVIEW = 'TotalApprovedInReviewByManufacturer',
  MFG_APPROVED = 'TotalApprovedByManufacturer',
  REJECTED_REBATEABLE_RXP_REVIEW = 'TotalRejectedRebateEligibleInReviewByHost',
  REJECTED_REBATEABLE_CUSTOMER_REVIEW = 'TotalRejectedRebateEligibleInReviewByCustomer',
  REJECTED_CUSTOMER_APPROVED = 'TotalRejectionsApprovedByCustomer',
  MFG_REJECTED = 'TotalRejectedByManufacturer',
  CUSTOMER_RESUBMISSION = 'TotalResubmittedByCustomer',
  CUSTOMER_RESUBMISSION_REJECTED = 'TotalCustomerResubmissionsRejectedByHost',
  //AUDIT_340B_BY_PLAN = 'TotalApprovedInReviewByHost',
  //AUDIT_340B_BY_MFR = 'TotalApprovedInReviewByHost',
  AUDIT_340B_BY_DRUG = 'TotalApprovedInReviewByHost_Drug',
  AUDIT_340B_BY_PRESCRIBER = 'TotalApprovedInReviewByHost_Prescriber',
  AUDIT_340B_BY_PHARMACY = 'TotalApprovedInReviewByHost_Pharmacy'
}
